
var Modal = require('ffss/ui/modal/Confirm');

class Alert extends Modal {

    defaultOptions(){
        var options = {
            'showBtnCancel': false,
        };
        return Object.assign(super.defaultOptions(),options);
    }


}

module.exports = Alert;